import { createContext, useCallback, useContext, useState } from 'react';
import { DocumentViewer } from '../components/documents/DocumentViewer';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const DocumentViewerContext = createContext({ openDocument: () => {} });

export const docFileUrl = (idOrSlug) => `${API}/documents/${idOrSlug}/file`;
export const isDocumentLike = (url = '') => {
  const clean = url.split('?')[0].toLowerCase();
  return clean.includes('/api/documents/') || clean.includes('/api/atlas-ai/knowledge-base/') || /\.(pdf|png|jpe?g|webp|docx?|xlsx?|pptx?)$/.test(clean);
};

export function DocumentViewerProvider({ children }) {
  const [doc, setDoc] = useState(null);

  // openDocument({ id | slug | url, title, filename })
  const openDocument = useCallback((opts) => {
    if (!opts) return;
    const url = opts.url || docFileUrl(opts.id || opts.slug);
    setDoc({ title: opts.title || 'Document', filename: opts.filename, url });
  }, []);

  return (
    <DocumentViewerContext.Provider value={{ openDocument }}>
      {children}
      <DocumentViewer doc={doc} onClose={() => setDoc(null)} />
    </DocumentViewerContext.Provider>
  );
}

export const useDocumentViewer = () => useContext(DocumentViewerContext);
